import React, {useEffect} from 'react';
import {Text, View} from 'react-native';
import {RHAvatar} from 'src/common-components/custom-ui-helpers';
import {Colors, Typography} from 'src/styles';
import {useStyle} from 'src/providers/style';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import {compose} from 'recompose';
import {User} from 'src/models';
import {TouchableOpacity} from 'react-native-gesture-handler';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {InputGroup} from 'src/design-system';
import StartTime from 'src/hook-form-inputs/start-time';
import EndTime from 'src/hook-form-inputs/end-time';
import Billable from 'src/hook-form-inputs/billable';
import Supervision from 'src/hook-form-inputs/supervision';
import ListItemSeparator from 'src/common-components/separator';
import Cpt from 'src/hook-form-inputs/cpt';
import {useFormContext, useWatch} from 'react-hook-form';
import {Q} from '@nozbe/watermelondb';
import {useDatabase} from '@nozbe/watermelondb/react';

const UserListItem = ({user, index, showTime, onClose, generalEvent}: any) => {
  const styles = useStyle();
  const database = useDatabase();
  let firstLineDisplay = '';
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  firstLineDisplay = firstName + ' ' + lastName;
  const firstInitial = firstName.length > 0 ? firstName[0].toUpperCase() : 'N';
  const lastInitial = lastName.length > 0 ? lastName[0].toUpperCase() : 'N';
  const avatar = firstInitial + lastInitial;

  const {control, setValue} = useFormContext();

  const watchedSupervision = useWatch({
    control,
    name: `selectedStaff.${index}.supervision`,
  });

  const watchedBillable = useWatch({
    control,
    name: `selectedStaff.${index}.billable`,
  });

  const watchedStartTime = useWatch({
    control,
    name: `selectedStaff.${index}.startTime`,
  });

  const watchedCpt = useWatch({
    control,
    name: `selectedStaff.${index}.cpt`,
  });

  const watchedNoteTemplate = useWatch({
    control,
    name: 'noteTemplate',
  });
  useEffect(() => {
    if (watchedSupervision) {
      if (watchedCpt?.includes('97155')) {
        return;
      } else {
        setValue(`selectedStaff.${index}.cpt`, [...watchedCpt, '97155']);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedSupervision]);

  useEffect(() => {
    if (watchedBillable === false) {
      if (watchedCpt?.includes('00000')) {
        return;
      } else {
        setValue(`selectedStaff.${index}.cpt`, [...watchedCpt, '00000']);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedBillable]);

  useEffect(() => {
    if (!watchedNoteTemplate && watchedCpt?.length) {
      const fetchTemplate = async () => {
        const associatedNoteTemplateVersion = await database
          .get('note_template_versions')
          .query(
            Q.where('cpt', watchedCpt[watchedCpt.length - 1]),
            Q.where('deleted_at', Q.eq(null)),
            Q.sortBy('version', Q.desc),
          )
          .fetch();
        if (associatedNoteTemplateVersion.length) {
          setValue(
            'noteTemplate',
            associatedNoteTemplateVersion[0].noteTemplateId,
          );
        }
      };
      fetchTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedCpt]);

  return (
    <View style={[styles.column, styles.paddingLVertical]}>
      <View
        style={[
          styles.row,
          styles.width,
          styles.justifySpaceBetween,
          styles.alignCenter,
        ]}>
        <View style={[styles.row, styles.alignCenter, styles.marginLRight]}>
          <RHAvatar
            label={avatar}
            color={Colors.RAVEN_BLACK}
            textColor={Colors.RAVEN_WHITE}
            size={32}
          />
          <View style={[styles.marginLLeft]}>
            <Text style={[Typography.P2_MEDIUM, styles.textColorPrimary]}>
              {firstLineDisplay}
            </Text>
            <Text style={[Typography.P3, styles.textColorSecondary]}>
              {user.permission}
            </Text>
          </View>
        </View>
        <TouchableOpacity style={[]} onPress={onClose}>
          <Icon name="close" size={20} />
        </TouchableOpacity>
      </View>
      <View style={[styles.marginLTop]}>
        {!generalEvent ? (
          <InputGroup
            orientation={'tabletContainer'}
            left={<Billable name={`selectedStaff.${index}`} />}
            right={<Supervision name={`selectedStaff.${index}`} />}
          />
        ) : null}
      </View>
      <View style={[styles.marginLVertical]}>
        {showTime ? (
          <InputGroup
            orientation={'tabletContainer'}
            left={<StartTime name={`selectedStaff.${index}`} />}
            right={
              <EndTime
                name={`selectedStaff.${index}`}
                date={watchedStartTime}
              />
            }
          />
        ) : null}
      </View>
      {!generalEvent ? (
        <Cpt name={`selectedStaff.${index}`} multiple={true} />
      ) : null}
      <ListItemSeparator />
    </View>
  );
};

export default compose(
  withDatabase,
  withObservables(['id'], ({id, database}: any) => ({
    user: database.get(User.table).findAndObserve(id),
  })),
)(UserListItem);
